module.exports = __webpack_public_path__ + "static/media/QC.d6296277.png";